import { useEffect, useState } from "react";
import { IKeyValue } from "../../../../components/Administrations/types";
import { useGetTrapRecieveSettingQuery, useUpdateTrapRecieveMutation } from "../../../../store/api/admin/adminApiSlice";
import { xsdPathStr } from "../../../../globals/constants";
import { isValidPassword } from "../../../../utils/validations";
import { useStoreDispatch } from "../../../../store/hooks";
import { setConfirmDialog, setErrorMsg, setOpenToast } from "../../../../store/helpers/helperReducers";
import { prepareTrapReceivePayload } from "../../../../components/helpers";
import { useSelector } from "react-redux";
import { selectedTrapSelector } from "../../../../store/api/admin/selectors";
import { setSelectedTrapReceive } from "../../../../store/api/admin/reducers";
import { errorMessage } from "../../../../utils/helpers";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { errorMsgSelector } from "../../../../store/helpers/helperSelectors";
import { store } from "../../../../store";
import { normalizeTrapProtocol } from "../helpers";

interface TrapReceiveData {
  engineId: string;
  userName: string;
  authPassword: string;
  privacyPassword: string;
  version: string;
  community: string;
  receivePort: string;
  authProtocol: string;
  privProtocol: string;
}

export const useTrapReceiveForm = () => {
  const dispatch = useStoreDispatch();
  const trapReceiveDetails = useSelector(selectedTrapSelector);
  const storeErrMsg = useSelector(errorMsgSelector);
  const { trapReceive } = xsdPathStr;
  const { data, refetch } = useGetTrapRecieveSettingQuery();
  const [updateTrapReceive] = useUpdateTrapRecieveMutation();
  const [trapReceiveData, setTrapReceiveData] = useState<any>(trapReceiveDetails);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [isPrivChecked, setIsPrivChecked] = useState(false);
  const [snmpv1v2, setSnmpv1v2] = useState(false);
  const [snmpv3, setSnmpv3] = useState(false);
  const [isFilterTrap, setIsFilterTrap] = useState(false);
  const [authConfirmPassword, setAuthConfirmPassword] = useState(trapReceiveDetails?.authPassword);
  const [privConfirmPassword, setPrivConfirmPassword] = useState(trapReceiveDetails?.privPassword);
  const [trapAuthPassword, setTrapAuthPassword] = useState("");
  const [trapPrivPassword, setTrapPrivPassword] = useState("");
  const [isAuthProtoChecked, setIsAuthProtoCehcked] = useState(false);
  const [isPrivProtoChecked, setIsPrivProtoCehcked] = useState(false);
  const [trapAuthConfirmPassword, setTrapAuthConfirmPassword] = useState("");
  const [trapPrivConfirmPassword, setTrapPrivConfirmPassword] = useState("");
  const [authPassword, setAuthPassword] = useState("");
  const [privPassword, setPrivPassword] = useState("");

  const clearInputList = {
    engineId: "", userName: "", community: "",
    authPassword: "", authConfirmPassword: "",
    privPassword: "", privConfirmPassword: "",
    trapAuthPassword: "", trapAuthConfirmPassword: "",
    trapPrivPassword: "", trapPrivConfirmPassword: "",
  };

  useEffect(() => {
    dispatch(setErrorMsg({ ...storeErrMsg, ...clearInputList }));
  }, []);

  // let errCount = 0;

  const isEngineIdValidString = (str: string, name: string) => {
    if (!str.startsWith("0x")) {
      return { [name]: `Should starts with 0x` };
    } else if (str.length < 10) {
      return { [name]: `Max length should be 10` };
    } else if (str.length % 2 !== 0) {
      return { [name]: `Total characters should be even` };
    }
    return null;
  };

  const onBlurHandler = (event: any) => {
    const { name, value } = event?.target;
    const existing = store.getState().helpers.errorMsg;

    const setErr = (field: string, msg: string) => {
      dispatch(setErrorMsg({ ...existing, [field]: msg }));
    };

    if (name === "snmpv1v2" && !trapReceiveData?.snmpv1v2) {
      setErr(name, `Please enable Snmpv1v2!!`);
    }
    if (snmpv3 && name === "engineId") {
      const errorObj = isEngineIdValidString(value, name);
      if (errorObj) {
        dispatch(setErrorMsg({ ...existing, ...errorObj }));
      }
      return;
    }
    if ((name === "authPassword" && trapReceiveData?.isAuthChecked) || (name === "authConfirmPassword" && trapReceiveData?.isAuthChecked)) {
      if (!!value) {
        const isValidPass = isValidPassword(value);
        if (!isValidPass) {
          setErr(name, `Password is invalid. It must meet the specified criteria!`);
        }
      }
    }
    if ((name === "privacyPassword" && trapReceiveData?.isPrivChecked) || (name === "privConfirmPassword" && trapReceiveData?.isPrivChecked)) {
      if (!!value) {
        const isValidPass = isValidPassword(value);
        if (!isValidPass) {
          setErr(name, `Password is invalid. It must meet the specified criteria!`);
        }
      }
    }
  };

  const handleInitialState = () => {
    setIsAuthChecked(false);
    setIsPrivChecked(false);
    setTrapAuthPassword("");
    setTrapPrivPassword("");
    setIsAuthProtoCehcked(false);
    setIsPrivProtoCehcked(false);
    setTrapAuthConfirmPassword("");
    setTrapPrivConfirmPassword("");
    setAuthPassword("");
    setPrivPassword("");
    setAuthConfirmPassword("");
    setPrivConfirmPassword("");
    dispatch(setErrorMsg({ ...store.getState().helpers.errorMsg, ...clearInputList }));
  };

  useEffect(() => {
    if (data) {
      const newData = {
        engineId: data[`${trapReceive?.engineId}`] || "",
        userName: data[`${trapReceive?.userName}`] || "",
        authPassword: authPassword || "",
        privacyPassword: privPassword || "",
        version: data[`${trapReceive?.version}`] || "",
        community: data[`${trapReceive?.community}`] || "",
        port: data[`${trapReceive?.port}`] || "",
        receivePort: data[`${trapReceive?.recievePort}`] || "162",
        authProtocol: normalizeTrapProtocol("auth", data[`${trapReceive?.authProtocol}`]),
        privProtocol: normalizeTrapProtocol("priv", data[`${trapReceive?.privProtocol}`]),
      };
      if (!!data[`${trapReceive?.community}`]) {
        setIsFilterTrap(true);
      }
      if (newData?.version?.toLowerCase() === "v2") {
        setSnmpv1v2(true);
        setSnmpv3(false);
      } else if (newData?.version?.toLowerCase() === "v3") {
        setSnmpv3(true);
        setSnmpv1v2(false)
      } else if (newData?.version?.toLowerCase() === "both") {
        setSnmpv1v2(true);
        setSnmpv3(true);
      }
      dispatch(setSelectedTrapReceive(newData));
      setTrapReceiveData({ ...trapReceiveData, ...newData });
      handleInitialState();
    }
  }, [data, refetch, dispatch]);

  useEffect(() => {
    if (!snmpv1v2 && !snmpv3) {
      setSnmpv1v2(true);
    }
    // if(!snmpv1v2){
    //   setIsFilterTrap(false);
    //   setTrapReceiveData({ ...trapReceiveData, community: "" })
    // }
    // if(snmpv1v2){
    //   trapReceiveDetails?.community && setIsFilterTrap(true);
    //   setTrapReceiveData({ ...trapReceiveData, community: trapReceiveDetails?.community  })
    // }
    if (!snmpv3) {
      handleInitialState();
    }
  }, [snmpv1v2, snmpv3]);

  const handleMsg = () => {
    // if(snmpv1v2 && !trapReceiveData?.community) {
    //   return "SNMP V1V2 is selected. Enter community."
    // }
    if (snmpv3 && !trapReceiveData?.userName) {
      return "SNMP V3C is selected. Enter userName."
    }
    if (snmpv3 && trapReceiveData?.authProtocol !== trapReceiveDetails?.authProtocol && trapReceiveData?.authProtocol?.toLowerCase() !== "no_auth" && !authPassword) {
      return "Authentication Protocol is selected and Password length is less than 8."
    }
    if (snmpv3 && trapReceiveData?.privProtocol !== trapReceiveDetails?.privProtocol && trapReceiveData?.privProtocol?.toLowerCase() !== "no_priv" && !privPassword) {
      return "Privacy Protocol is selected and Password length is less than 8."
    }
  }

  const handleValidateVersion = () => {
    let isValid: boolean = true;
    // if(snmpv1v2 && !trapReceiveData?.community) {
    //   dispatch(setConfirmDialog(DIALOGOPENFOR.TRAPRECEIVE));
    //   isValid = false;
    // }
    if (snmpv3 && !trapReceiveData?.userName) {
      dispatch(setConfirmDialog(DIALOGOPENFOR.TRAPRECEIVE));
      isValid = false;
    }
    if (snmpv3 && trapReceiveData?.authProtocol !== trapReceiveDetails?.authProtocol && trapReceiveData?.authProtocol?.toLowerCase() !== "no_auth" && !authPassword) {
      dispatch(setConfirmDialog(DIALOGOPENFOR.TRAPRECEIVE));
      isValid = false;
    }
    if (snmpv3 && trapReceiveData?.privProtocol !== trapReceiveDetails?.privProtocol && trapReceiveData?.privProtocol?.toLowerCase() !== "no_priv" && !privPassword) {
      dispatch(setConfirmDialog(DIALOGOPENFOR.TRAPRECEIVE));
      isValid = false;
    }
    return isValid;
  }

  const handleSelectVersion = () => {
    dispatch(setConfirmDialog(undefined));
  }

  const handleResetTrapRecieve = () => {
    if (data) {

      const version = data[`${trapReceive?.version}`]?.toLowerCase();

      const newData = {
        engineId: data[`${trapReceive?.engineId}`] || "",
        userName: data[`${trapReceive?.userName}`] || "",
        authPassword: authPassword || "",
        privPassword: privPassword || "",
        version: data[`${trapReceive?.version}`] || "",
        community: data[`${trapReceive?.community}`] || "",
        // port: data[`${trapReceive?.port}`] || "",
        // receivePort: data[`${trapReceive?.recievePort}`] || "",
        authProtocol: normalizeTrapProtocol("auth", data[`${trapReceive?.authProtocol}`]),
        privProtocol: normalizeTrapProtocol("priv", data[`${trapReceive?.privProtocol}`]),
      };

      setTrapReceiveData((prev: TrapReceiveData) => ({
        ...prev,
        ...newData,
      }));


      if (version === "v2") {
        setSnmpv1v2(true);
        setSnmpv3(false);
      } else if (version === "v3") {
        setSnmpv1v2(false);
        setSnmpv3(true);
      } else if (version === "both") {
        setSnmpv1v2(true);
        setSnmpv3(true);
      }

      setIsFilterTrap(!!newData.community);
      handleInitialState();
    }
  };

  const submitHandler = async () => {
    if (handleValidateVersion()) {
      try {
        let result: any;
        const existing = store.getState().helpers.errorMsg;

        if (authPassword !== authConfirmPassword) {
          dispatch(setErrorMsg({ ...existing, authConfirmPassword: "Passwords do not match" }));
          return;
        }
        if (privPassword !== privConfirmPassword) {
          dispatch(setErrorMsg({ ...existing, privConfirmPassword: "Passwords do not match" }));
          return;
        }

        if (snmpv3) {
          const errorObj = isEngineIdValidString(trapReceiveData?.engineId, "engineId");
          if (errorObj) {
            dispatch(setErrorMsg({ ...store.getState().helpers.errorMsg, ...errorObj }));
            return;
          }
        }


        result = await updateTrapReceive(
          prepareTrapReceivePayload(
            trapReceiveData,
            snmpv1v2,
            snmpv3,
            isAuthProtoChecked,
            isPrivProtoChecked,
            authPassword,
            privPassword,
            trapAuthPassword,
            trapPrivPassword
          )
        );
        if (result?.error) throw result?.error;
        if (result.data?.status === 200) {
          dispatch(
            setOpenToast({
              openToast: true,
              toastType: "success",
              message: "The data has been  updated for Trap Receive",
            })
          );
          refetch();
        }
      } catch (error: any) {
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
      }
    }
  };

  return {
    trapReceiveData,
    setTrapReceiveData,
    onBlurHandler,
    handleResetTrapRecieve,
    submitHandler,
    isAuthChecked,
    setIsAuthChecked,
    isPrivChecked,
    setIsPrivChecked,
    snmpv1v2,
    setSnmpv1v2,
    snmpv3,
    setSnmpv3,
    trapAuthConfirmPassword,
    setTrapAuthConfirmPassword,
    trapAuthPassword,
    setTrapAuthPassword,
    trapPrivConfirmPassword,
    setTrapPrivConfirmPassword,
    trapPrivPassword,
    setTrapPrivPassword,
    authConfirmPassword,
    setAuthConfirmPassword,
    privConfirmPassword,
    setPrivConfirmPassword,
    isAuthProtoChecked,
    setIsAuthProtoCehcked,
    isPrivProtoChecked,
    setIsPrivProtoCehcked,
    isFilterTrap,
    setIsFilterTrap,
    authPassword,
    setAuthPassword,
    privPassword,
    setPrivPassword,
    handleMsg,
    handleSelectVersion
  };
};
